"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorLabel = function ErrorLabel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      htmlFor = _ref.htmlFor;
  var classes = (0, _classnames.default)('font-normal text-gray-400 text-sm tracking-wider pt-4 text-red-400', className);
  return /*#__PURE__*/_react.default.createElement("label", {
    className: classes,
    htmlFor: htmlFor
  }, children);
};

ErrorLabel.propTypes = {
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  htmlFor: _propTypes.default.string
};
var _default = ErrorLabel;
exports.default = _default;